'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RelationshipModel = function () {
  function RelationshipModel(data) {
    _classCallCheck(this, RelationshipModel);

    this.person = null;
    this.target = null;

    this.values = {
      id: null,
      person_id: null,
      target_id: null,
      description: null
    };

    window.PRIM.modelMapper.mapToModel(data, this.values);
  }

  _createClass(RelationshipModel, [{
    key: 'getTitle',
    value: function getTitle() {
      var title = [];

      if (this.target && this.target.getTitle) {
        return this.target.getTitle();
      }

      return title.join(' ');
    }
  }, {
    key: 'getSubtitle',
    value: function getSubtitle() {
      return [this.values.description].join(' ');
    }
  }, {
    key: 'getImage',
    value: function getImage() {
      if (this.target && this.target.getImage) {
        return this.target.getImage();
      } else {
        return null;
      }
    }
  }, {
    key: 'getIndex',
    value: function getIndex() {
      if (this.target && this.target.getIndex) {
        return this.target.getIndex();
      }

      return null;
    }
  }, {
    key: 'getCompareString',
    value: function getCompareString() {
      var title = [];

      if (this.target && this.target.getCompareString) {
        title.push(this.target.getCompareString());
      }

      if (this.values.description) {
        title.push(this.values.description);
      }

      return title.join(' ');
    }
  }, {
    key: 'getJSON',
    value: function getJSON() {
      var result = {};

      window.PRIM.modelMapper.mapToObject(this.values, result);

      return result;
    }
  }]);

  return RelationshipModel;
}();

exports.default = RelationshipModel;


//////////////////
// WEBPACK FOOTER
// ./js/modules/relationship/model/RelationshipModel.js
// module id = 13
// module chunks = 0